import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchOptionGroup } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import ViewOptionGroup from '../components/optiongroups/ViewOptionGroup';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  optiongroups: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
};

class OptionGroupViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchOptionGroup(this.props.params.id));
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="optiongroup component" style={authPage}>
        <h2>View Option Group</h2>
        <div className="content">
          <ViewOptionGroup
            optiongroup={this.props.optiongroups.optiongroup}
          />
        </div>
      </div>
    );
  }
}

OptionGroupViewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

OptionGroupViewPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    optiongroups: state.optiongroups,
  };
}

export default withRouter(connect(mapStateToProps)(OptionGroupViewPage));



// WEBPACK FOOTER //
// ./src/containers/OptionGroupViewPage.js